export const IconSortyByDisabled = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 8.5L12 15.5L19 8.5" stroke="#EBEBE4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}